import React from 'react';
import { Button } from '@skin-seoul/design-system';
import { COLORS, FONT_FAMILIES } from '../constants';

type ButtonProps = React.ComponentProps<typeof Button>;

export const SelectButton = React.forwardRef<
  HTMLButtonElement,
  {
    children: React.ReactNode;
    onClick: () => void;
  } & Omit<ButtonProps, 'children' | 'onClick'>
>(({ children, onClick, ...props }, ref) => (
  <Button
    variant="outline"
    className="w-full h-[36px] bg-generic-0 text-neutral-700 rounded-[8px] border-neutral-100 border text-paragraph-small cursor-pointer inline-flex items-center justify-between whitespace-nowrap hover:bg-neutral-50"
    ref={ref}
    onClick={onClick}
    {...props}
  >
    {children}
  </Button>
));

SelectButton.displayName = 'SelectButton';

export const OptionsList = React.forwardRef<
  HTMLDivElement,
  {
    children: React.ReactNode;
  } & React.HTMLAttributes<HTMLDivElement>
>(({ children, ...props }, ref) => (
  <div ref={ref} className="flex flex-col gap-4 tablet:gap-[10px]" {...props}>
    {children}
  </div>
));

OptionsList.displayName = 'OptionsList';

export const OptionItem = ({
  children,
  isSelected,
  onClick,
  style,
  ...props
}: {
  children: React.ReactNode;
  isSelected: boolean;
  onClick: () => void;
  style?: React.CSSProperties;
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'onClick'>) => (
  <div
    className="flex items-center justify-between w-full p-0 tablet:p-4 text-left cursor-pointer hover:bg-[#f5f5f5]"
    style={{
      fontSize: '14px',
      color: isSelected ? COLORS.primary : COLORS.textSecondary,
      fontFamily: FONT_FAMILIES.primary,
      ...style,
    }}
    onClick={onClick}
    {...props}
  >
    {children}
  </div>
);

export const CheckIcon = ({
  children,
  ...props
}: {
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLSpanElement>) => (
  <span style={{ color: COLORS.primary, fontSize: '18px' }} {...props}>
    {children}
  </span>
);
